import * as types from '../mutation-types';

// initial state
const state = () => ({
  acceptedDate: null,
});

// getters
const getters = {
  trackAndTraceAccepted: (state) => {
    if (!state.acceptedDate) {
      return false;
    }

    const dayStartHour = 5;

    const now = new Date();

    // compare with previous day if not beyond day start hour threshold!
    if (now.getHours() < dayStartHour) {
      now.setDate(now.getDate() - 1);
    }

    // see if they accepted after dayStartHour today
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), dayStartHour);

    // see if they accepted after 8am today
    const acceptedDate = new Date(state.acceptedDate);

    return acceptedDate >= today;
  },
};

// actions
const actions = {
  acceptTrackAndTrace({ commit }) {
    commit(types.TRACK_AND_TRACE_ACCEPTED);
  },
};

// mutations
const mutations = {
  [types.TRACK_AND_TRACE_ACCEPTED](state) {
    state.acceptedDate = new Date();
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
